import axios from 'axios';
import { API_URL } from '../config/api';

const headers = () => {
  const token = localStorage.getItem('token');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

export const TARGET_TASK = 'TASK';
export const TARGET_WORKFLOW = 'WORKFLOW';

export const fetchWorkTimers = async () => {
  const response = await axios.get(`${API_URL}/work-timers`, { headers: headers() });
  return Array.isArray(response.data) ? response.data : [];
};

export const applyWorkTimer = async (targetType, targetId, action) => {
  const response = await axios.post(
    `${API_URL}/work-timers`,
    { targetType, targetId, action },
    { headers: headers() },
  );
  return response.data;
};

export const consumeWorkTimer = async (targetType, targetId) => {
  const response = await axios.post(
    `${API_URL}/work-timers/consume`,
    { targetType, targetId },
    { headers: headers() },
  );
  const minutes = Number(response.data?.minutes);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : null;
};
